import { useEffect, useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Dropdown } from '@zeeve-platform/dropdown-component';
import axios from 'axios';
import Footer from '../../../components/NextAndPrev';
import { getNetworkList } from '../../../services/network';
import { getWorkspaceListData } from '../../../services/global';
import Urls from '../../../utils/baseUrls';
import { NetworkDataZoneTypes,DefaultObjectType, ListFormattedType } from '../declaration';

// Types of Props
interface Props {
    first: boolean;
    prev: () => void;
    nextPage: () => void;
    setNetworkDataZone: (obj: NetworkDataZoneTypes) => void;
    submit: () => void;
    defaultObject: DefaultObjectType;
    setDefaultObject: (obj: DefaultObjectType) => void;
    last: boolean;
    networkDataZone: NetworkDataZoneTypes;
}

// Types of Networks
interface NetworkTypeInterfce {
    id: number | string;
    chainId: string | number;
    networkName: string;
    network: string;
    defaultConfig: {
        apis: string[];
        syncMode: string;
        gcMode: string;
        ipcRPC: boolean;
        txLookupLimit: number;
    };
    nodeTypes: string[];
}

// Types of workspace
interface WorkspaceType {
    id: number | string;
    name: string;
    networks: number | string;
    nodes: number | string;
    members: number | string;
    createdAt: number | string;
    success?: boolean;
}

const NetworkSelection = ({
    first,
    prev,
    nextPage,
    setNetworkDataZone,
    last,
    networkDataZone,
    submit,
    defaultObject,
    setDefaultObject,
}: Props) => {
    const [showNext, setNext] = useState({
        s1: false,
        s2: false,
        s3: false,
        s4: false,
    });
    const [workspaces, setWorkspace] = useState([] as WorkspaceType[]);
    const [isValidNetName, setIsValidNetName] = useState<boolean>(false);
    const [networkTypeList, setNetworkTypeList] = useState([] as NetworkTypeInterfce[]);
    const deploymentId: string = Urls.getDeploymentId();

    const handleNetworkSelect = (value: string) => {
        setNetworkDataZone({
            ...networkDataZone,
            network: value,
        });
        const index = networkTypeList.findIndex((item) => item.network === value);
        const obj = networkTypeList[index];
        setDefaultObject({
            ...defaultObject,
        });
        setNext({ ...showNext, s2: true });
    };

    const unsetHighlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (b.classList.contains('formEmptyText')) {
                    b.classList.remove('formEmptyText');
                }
            } else {
                b.style.borderColor = '#ECEEF3';
            }
        }
    };

    const highlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (!b.classList.contains('formEmptyText')) {
                    b.classList.add('formEmptyText');
                }
            } else {
                b.style.borderColor = 'red';
            }
        }
    };

    const networkList = async () => {
        try {
            const res: any = await getNetworkList('all', 'dedicated');
            // const res: any = await (await axios.get('http://localhost:3001/networks/defaults/asdasd')).data;
            if (res && res.success) {
                if (res.data.length > 0) {
                    setNetworkTypeList(res.data);
                } else {
                    setNetworkTypeList([]);
                }
            } else {
                setNetworkTypeList([]);
            }
        } catch (error) {
            setNetworkTypeList([]);
        }
    };
    const getWorkspaceList = async () => {
        try {
            const response: any = await getWorkspaceListData();
            // const response: any = await (await axios.get('http://localhost:3001/workspace/list')).data;
            if (response && response.success) {
                setWorkspace(response.data);
            } else {
                setWorkspace([]);
            }
        } catch (error) {
            setWorkspace([]);
        }
    };

    const networkListModify = (arr: NetworkTypeInterfce[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: item.networkName,
                    value: item.network,
                });
            });
        }
        return data;
    };

    const workspaceListModify = (arr: WorkspaceType[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: item.name,
                    value: item.id,
                });
            });
        }
        return data;
    };

    useEffect(() => {
        // Api call for get network list data
        networkList();
        // Api call for get workspace list data
        getWorkspaceList();
        if ('networkName' in networkDataZone && networkDataZone.networkName !== '') {
            setIsValidNetName(true);
        }
    }, []);

    const handleInput = (val: string, op: string) => {
        const etag = document.getElementById('err2');
        switch (op) {
            case 'name':
                if (val.length < 5) {
                    highlight('z11', false);
                    setIsValidNetName(false);
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the network name should not be less than 5.';
                    }
                } else if (val.length > 20) {
                    highlight('z11', false);
                    setIsValidNetName(false);
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the network name should not be more than 20.';
                    }
                } else if (!/[a-z]/i.test(val.charAt(0))) {
                    highlight('z11', false);
                    setIsValidNetName(false);
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Network name should start with an alphabet.';
                    }
                    break;
                } else if (!/^[A-Za-z0-9]*$/.test(val.charAt(val.length - 1))) {
                    highlight('z11', false);
                    setIsValidNetName(false);
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Network name should end with an alphabet or a number.';
                    }
                    break;
                } else if (!/^([A-Za-z0-9\s-])*$/.test(val)) {
                    highlight('z11', false);
                    setIsValidNetName(false);
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Network name can only contain alphabet, number, space and hyphen.';
                    }
                    break;
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    setIsValidNetName(true);
                    unsetHighlight('z11', false);
                    setNext({ ...showNext, s1: true });
                    setNetworkDataZone({ ...networkDataZone, networkName: val });
                }
                break;
            default:
                break;
        }
    };
    const solve = () => {
        if (
            'networkName' in networkDataZone &&
            networkDataZone.networkName !== '' &&
            isValidNetName &&
            'network' in networkDataZone &&
            networkDataZone.network !== '' &&
            'workspaceId' in networkDataZone &&
            networkDataZone.workspaceId !== '' &&
            'deploymentType' in networkDataZone &&
            networkDataZone.deploymentType !== ''
        ) {
            return nextPage();
        }
        if (!isValidNetName) {
            return highlight('z11', false);
        }
        if (!('network' in networkDataZone && networkDataZone.network !== '')) {
            return highlight('z12', false);
        }
        if (!('deploymentType' in networkDataZone && networkDataZone.deploymentType !== '')) {
            return highlight('z13', false);
        }
        return highlight('z14', false);
    };

    return (
        <>
            <div className=' mt-3 col-11 mx-auto'>
                <div className='col-xl-10 col-lg-8 col-sm-12 mx-auto'>
                    <div className='row'>
                        <div className='form col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                            <div className='mt-4 col-11 marginauto form-floating cordaversion'>
                                <h6 className='mx-3 mt-3'>Name your Network</h6>
                                <Inputbox
                                    type='text'
                                    className='mx-2 mt-3 col-12 form-control py-0'
                                    style={{ height: 'calc(3rem + 2px)' }}
                                    defaultValue={networkDataZone.networkName}
                                    required
                                    id='z11'
                                    onChange={(e: { target: { value: string } }) => {
                                        handleInput(e.target.value, 'name');
                                    }}
                                />
                            </div>
                        </div>
                        <div className='col-xl-5 col-lg-4 col-md-12 col-sm-12'>
                            <div className='mt-4 col-11 marginauto form-floating cordaversion'>
                                <h6 className='mx-3 mt-4'>Select Type of Network</h6>
                                <Dropdown
                                    id='z12'
                                    onChange={(e: { target: { value: string } }) => {
                                        unsetHighlight('z12', false);
                                        handleNetworkSelect(e.target.value);
                                        // setNetworkDataZone({
                                        //   ...networkDataZone,
                                        //   network: e.target.value,
                                        // });
                                    }}
                                    options={networkListModify(networkTypeList)}
                                    defaultValue={networkDataZone.network}
                                    dropDownStyle={{ height: '50px' }}
                                    className='form-borderradius form-select mx-2 mt-3'
                                    selectTitle='Select Network Type'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xl-5 col-lg-4 col-md-12 col-sm-12'>
                            <div className='mt-4 col-11  form-floating cordaversion'>
                                <h6 className='mx-3 mt-3'>Select Deployment Type</h6>
                                <Dropdown
                                    id='z13'
                                    onChange={(e) => {
                                        unsetHighlight('z13', false);
                                        setNext({ ...showNext, s3: true });
                                        setNetworkDataZone({
                                            ...networkDataZone,
                                            deploymentType: e.target.value,
                                        });
                                    }}
                                    options={[
                                        {
                                            value: deploymentId,
                                            label: 'Native Shardeum Deployment',
                                        },
                                    ]}
                                    defaultValue={networkDataZone.deploymentType}
                                    dropDownStyle={{ height: '50px' }}
                                    className='form-borderradius form-select mx-2 mt-3'
                                    selectTitle='Select Deployment Type'
                                />
                            </div>
                        </div>
                        <div className='col-xl-5 col-lg-4 col-md-12 col-sm-12'>
                            <div className='mt-4 col-11 marginauto form-floating cordaversion'>
                                <h6 className='mx-3 mt-3'>Select Workspace</h6>
                                <Dropdown
                                    id='z14'
                                    onChange={(e) => {
                                        unsetHighlight('z14', false);
                                        setNext({ ...showNext, s4: true });
                                        setNetworkDataZone({
                                            ...networkDataZone,
                                            workspaceId: e.target.value,
                                        });
                                    }}
                                    className='form-borderradius form-select mx-2 mt-3'
                                    dropDownStyle={{ height: '50px', lineHeight: '2' }}
                                    defaultValue={networkDataZone.workspaceId}
                                    options={workspaceListModify(workspaces)}
                                    selectTitle='Select Workspace'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <p id='err2' className='text-center mt-4 mb-4' style={{ color: 'red', display: 'none' }}>
                    Error
                </p>
            </div>
            {/* <Footer last={last} submit={submit} showNext={false} first={first} nextPage={solve} prev={prev} /> */}
            <Footer
                isLastPage={last}
                submit={solve}
                isFirstPage={first}
                nextPage={solve}
                prevPage={prev}
                submitText='Create'
            />
        </>
    );
};
export default NetworkSelection;
